export const VIDEO_BOX_REQUEST = Symbol('VIDEO_BOX_REQUEST');
export const VIDEO_BOX_HOME_REQUEST = Symbol('VIDEO_BOX_HOME_REQUEST');
export const VIDEO_BOX_SUCCESS = Symbol('VIDEO_BOX_SUCCESS');
export const VIDEO_BOX_ERROR = Symbol('VIDEO_BOX_ERROR');
export const VIDEO_BOX_RESET = Symbol('VIDEO_BOX_RESET');
export const UPDATE_VIDEO_UPLOADER = Symbol('UPDATE_VIDEO_UPLOADER');
export const UPDATE_VIDEO_RESPONSIBLE_USER = Symbol('UPDATE_VIDEO_RESPONSIBLE_USER');
export const UPDATE_VIDEO_SAVED = Symbol('UPDATE_VIDEO_SAVED');

//FIXME - action creator can't have any logic of this type
//TODO: @Constantin handled videoId in front of action creator
//@techdebt
export const videoBoxRequestAction = (videoId) =>
  videoId && {
    type: VIDEO_BOX_REQUEST,
    payload: {
      videoId,
    },
  };

export const videoBoxHomeRequestAction = () => ({
  type: VIDEO_BOX_HOME_REQUEST,
  payload: {},
});

export const videoBoxSuccessAction = (video) => ({
  type: VIDEO_BOX_SUCCESS,
  payload: {
    video,
  },
});

export const updateVideoUploaderInfoAction = (videoUploader) => ({
  type: UPDATE_VIDEO_UPLOADER,
  payload: {
    videoUploader,
  },
});

export const updateVideoResponsibleUserAction = (responsibleUser) => ({
  type: UPDATE_VIDEO_RESPONSIBLE_USER,
  payload: {
    responsibleUser,
  },
});

export const updateVideoSavedAction = (saved) => ({
  type: UPDATE_VIDEO_SAVED,
  payload: {
    saved,
  },
});

export const videoBoxErrorAction = (message) => ({
  type: VIDEO_BOX_ERROR,
  payload: {
    error: message,
  },
});

export const videoBoxResetAction = () => ({ type: VIDEO_BOX_RESET });
